module.exports = __webpack_public_path__ + "static/media/solo51.0963c185.JPG";